<template>
    <v-card
        :style="`min-width: ${width}px`"
        class="mr-6 pb-1 pt-3">

        <v-card-title
            class="pt-0 mt-n1"
            v-html="element.name" />

        <v-card-subtitle
            v-if="element.description"
            v-text="element.description"
            class="pb-0"/>

        <v-card-subtitle
            v-if="element.position"
            class="pb-1"
            v-html="element.position" />

        <v-card-text class="d-flex align-center justify-center py-1 competence-text">
            <v-img
                :src="element.image.url"
                contain
                :width="element.image.width"
                :height="element.image.height" />
        </v-card-text>

        <v-card-actions class="px-4">
            <div v-if="element.from">
                <span
                    v-if="!element.to"
                    v-html="'Depuis&nbsp;'"/>
                <span v-text="element.from"/>
                <span
                    v-if="element.to && element.to !== element.from"
                    v-html="'&nbsp;-&nbsp;' + element.to"/>
            </div>

            <div
                v-if="element.years"
                v-text="element.years" />
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'hobbiesElement',
    props: {
        element: {
            type: Object,
            required: true
        },
        width: {
            type: Number,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/variables';

.v-card {
    min-width: 216px !important;

    .competence-text {
        width: 100% !important;
        height: 115px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/hobbies/hobbiesElement.vue